
import { useParams } from "react-router-dom";

import { DisenioLoteDistribuido } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, FBAFuncion, TablaListadoPlanillas, TablaTotalLIstPlanilla } from "../../components";
import { useDistriAndDescuentos, usePlanillasXLoteDistri } from "../../../hooks";
import { Box } from "@mui/material";





export const ListadoPlanillas = () => {


    const { id } = useParams();
    const { handleCrearPlanilla } = useDistriAndDescuentos();
    const { planillaLoteQuery, chagePage, page, termino, chageTermino } = usePlanillasXLoteDistri(id);


    return (

        <DisenioLoteDistribuido titulo={`Listado de Planillas`}>
            {(planillaLoteQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Planillas..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar planilla...' place='Buscar x numero, cliente...'
                />
                
                <TablaTotalLIstPlanilla />
                <TablaListadoPlanillas data={planillaLoteQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

            <Box sx={{height:30}} />
            <FBAFuncion funcion={ handleCrearPlanilla } icono="plus" />
        </DisenioLoteDistribuido>


    )
}
